import React from 'react';
import TextWinds from '../../common/TextWinds';

interface OrderDetailLayoutProps {
  title: string;
  children: React.ReactNode;
}
const OrderDetailLayout = ({ title, children }: OrderDetailLayoutProps) => {
  return (
    <div className="flex flex-col gap-y-2">
      <TextWinds type="sub_title01">{title}</TextWinds>
      <div className="rounded-lg border border-gray2 bg-gray0 p-3">
        <div className="flex flex-col gap-y-2">{children}</div>
      </div>
    </div>
  );
};

export const OrderDetailRow = ({
  label,
  value,
}: {
  label: string;
  value: React.ReactNode;
}) => {
  return (
    <div className="flex items-center justify-between">
      <TextWinds type="content_body4" color="gray7">
        {label}
      </TextWinds>
      <div>{value}</div>
    </div>
  );
};

export const OrderDetailDivider = () => {
  return <div className="my-2 h-[1px] w-full bg-gray2" />;
};

export default OrderDetailLayout;
